import { Hero, Page } from '@hbo/ui-servicing-react-components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const ErrorBoundaryContent: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.querySelector<HTMLElement>('h1')?.setAttribute('tabIndex', '-1');
    document.querySelector<HTMLElement>('h1')?.focus();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero>
        <Hero.PrimaryContent title={t('errorBoundaryPage.title')} />
      </Hero>
      <Page>
        <Page.Content>
          <p>{t('errorBoundaryPage.text', { appName: t('app.name') })}</p>
        </Page.Content>
      </Page>
    </>
  );
};

export default ErrorBoundaryContent;
